import PropTypes from 'prop-types';

import { FolderIcon, LoaderSkeleton, truncateTextWithEllipsis } from '@utilities';

import { helpTooltip } from './utilities/helpers';
import styles from './_index.module.scss';

const AttributeList = ({ attributes, isLoading, setActiveAttribute }) => {
  if (isLoading)
    return (
      <LoaderSkeleton height={130}>
        <rect height="15" rx="2" ry="2" width="200" x="0" y="0" />
        <rect height="15" rx="2" ry="2" width="175" x="0" y="25" />
        <rect height="15" rx="2" ry="2" width="225" x="0" y="50" />
        <rect height="15" rx="2" ry="2" width="200" x="0" y="75" />
        <rect height="15" rx="2" ry="2" width="225" x="0" y="100" />
      </LoaderSkeleton>
    );

  return (
    <ul className={styles['attribute-list']}>
      {attributes.map((attribute, index) => {
        const attributeName = truncateTextWithEllipsis({ text: attribute?.name });

        const tooltip = helpTooltip(attribute);

        return (
          <li key={`attribute-${index}`}>
            <button onClick={() => setActiveAttribute(attribute)}>
              <FolderIcon /> {attributeName}
            </button>
            {tooltip}
          </li>
        );
      })}
    </ul>
  );
};

AttributeList.propTypes = {
  attributes: PropTypes.array,
  isLoading: PropTypes.bool,
  setActiveAttribute: PropTypes.func,
};

export default AttributeList;
